import { render, staticRenderFns } from "./ProblemSolving.vue?vue&type=template&id=2516ff8c&scoped=true&"
import script from "./ProblemSolving.vue?vue&type=script&lang=js&"
export * from "./ProblemSolving.vue?vue&type=script&lang=js&"
import style0 from "./ProblemSolving.vue?vue&type=style&index=0&id=2516ff8c&lang=scss&scoped=true&"
import style1 from "./ProblemSolving.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2516ff8c",
  null
  
)

export default component.exports